<template>
    <div class="app-section">
        <div class="app-content">
            <h2 class="app-title fuente-posm">
                Tu Propia Aplicación Móvil
            </h2>
            <p class="app-text fuente-nova">
                Destaca en el mercado digital con una app exclusiva para tu negocio.
                <br><br>
                Impulsa las ventas recurrentes, envía notificaciones de promociones y construye una comunidad fiel a tu marca.
            </p>
        </div>
        <div class="app-image">
            <img :src="a71" alt="Aplicación móvil">
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppMovilNew',
    data() {
        return {
            a71: require('@/assets/images/a71.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.app-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.app-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.app-image img {
    width: 280px;
    height: auto;
}

.app-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.app-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.app-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .app-title {
        font-size: 60px;
    }

    .app-text {
        font-size: 27px;
    }

    .app-image img {
        width: 220px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .app-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .app-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .app-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .app-image img {
        width: 50%;
        max-width: 200px;
    }

    .app-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .app-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
